<template>
  <section id="map-left-popup">
    <el-drawer
      title="我是标题"
      :with-header="false"
      :visible.sync="modelValue"
      direction="ltr"
      :before-close="handleClosePopup"
      size="365px"
      :modal-append-to-body="true"
      :modal="false"
    >
      <div class="map-search">
        <!-- <el-input
          suffix-icon="el-icon-search"
          placeholder="请输入建筑名称"
          v-model="architectureName"
        ></el-input> -->
        <el-select
          v-model="searchValue"
          filterable
          remote
          reserve-keyword
          placeholder="请输入建筑名称"
          :remote-method="handleSearchRelicInMap"
          :loading="loading"
          @change="handleConfirmRelic"
        >
          <el-option
            v-for="item in options"
            :key="item.relicAutoIncrementId"
            :label="item.relicName"
            :value="item.relicAutoIncrementId"
          >
          </el-option>
        </el-select>
        <img
          class="map-search__icon"
          src="../../assets/images/normal_search.svg"
          alt=""
        />
      </div>
      <!-- 建筑类别 -->
      <div class="map-select">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="建筑类别" name="1">
            <el-checkbox-group
              v-model="typeList"
              size="medium"
              @change="handleFileter"
            >
              <el-checkbox-button
                v-for="categoryItem in relicTypecounts"
                :label="categoryItem.propertyEnum"
                :key="categoryItem.propertyEnum"
              >
                <span class="tag-label">{{ categoryItem.label }}</span>
                <span class="tag-amount checked-amount">
                  {{ categoryItem.count }}
                </span>
              </el-checkbox-button>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="建筑等级" name="2">
            <el-checkbox-group
              v-model="levelList"
              size="medium"
              @change="handleFileter"
            >
              <el-checkbox-button
                v-for="categoryItem in protectionLevelcounts"
                :label="categoryItem.propertyEnum"
                :key="categoryItem.propertyEnum"
              >
                <span class="tag-label">{{ categoryItem.label }}</span>
                <span class="tag-amount checked-amount">
                  {{ categoryItem.count }}
                </span>
              </el-checkbox-button>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="行政区域" name="3">
            <el-checkbox-group
              v-model="addressList"
              size="medium"
              @change="handleFileter"
            >
              <el-checkbox-button
                v-for="categoryItem in relicAddresscounts"
                :label="categoryItem.propertyEnum"
                :key="categoryItem.propertyEnum"
              >
                <span class="tag-label">{{ categoryItem.label }}</span>
                <span class="tag-amount checked-amount">
                  {{ categoryItem.count }}
                </span>
              </el-checkbox-button>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
        <span @click="handleClearValue" class="map-search-clear font-h3"
          >清空</span
        >
      </div>
    </el-drawer>
  </section>
</template>

<script>
import { searchRelicListInMap } from '../../api';
import { modelMixin } from '../../assets/js/mixins/model';
export default {
  name: 'MapLeftPopup',
  mixins: [modelMixin],
  props: {
    relicCountData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    relicTypecounts() {
      return this.relicCountData.relicTypecounts;
    },
    protectionLevelcounts() {
      return this.relicCountData.protectionLevelcounts;
    },
    relicAddresscounts() {
      return this.relicCountData.relicAddresscounts;
    }
  },
  data() {
    return {
      loading: false,
      searchValue: '',
      options: [],
      activeNames: '',
      typeList: [], //建筑类别
      levelList: [], //建筑级别
      addressList: [], //行政区域
      architectureName: ''
    };
  },
  methods: {
    /**
     *关闭弹窗回调
     */
    handleClosePopup() {
      this.modelValue = false;
    },
    /**
     *清空输入框回调
     */
    handleClearValue() {
      this.searchValue = '';
      this.typeList = [];
      this.levelList = [];
      this.addressList = [];
      this.$emit(
        'onChangeByFilter',
        this.levelList,
        this.addressList,
        this.typeList
      );
    },
    /**
     * 类型变化回掉
     */
    handleFileter() {
      this.$emit(
        'onChangeByFilter',
        this.levelList,
        this.addressList,
        this.typeList
      );
    },
    /**
     * 搜索框远程搜索
     */
    handleSearchRelicInMap(query) {
      let protectionLevelEnums = this.levelList.join('&protectionLevelEnums=');
      let relicDistrictEnums = this.addressList.join('&relicDistrictEnums=');
      let relicTypeEnums = this.typeList.join('&relicTypeEnums=');

      searchRelicListInMap({
        protectionLevelEnums,
        relicTypeEnums,
        relicDistrictEnums,
        frameContent: query
      }).then(res => {
        if (res.data.code == 200) {
          const { items } = res.data.data;
          this.options = items.filter(e => {
            return e.coordinate?.x;
          });
        }
      });
    },
    /**
     * 确定建筑回掉
     */
    handleConfirmRelic(relicId) {
      this.$emit('onSearchSuccessRelic', relicId);
      this.options = [];
      this.searchValue = '';
      this.modelValue = false;
    }
  }
};
</script>

<style lang="scss">
#map-left-popup {
  .el-drawer {
    &__wrapper {
      z-index: 1000 !important;
    }
    padding: 18px 22px;
    padding-left: 65px;
    max-width: 100vw !important;
    &__body {
      padding: 18px;
      overflow: auto;
    }
    .el-collapse {
      // overflow: auto;
      // height: 80vh;
      margin-bottom: 20px;
    }
    .map-search {
      padding-bottom: 20px;
      &__icon {
        position: relative;
        top: 5px;
        right: 20px;
      }
      .el-input {
        &__inner {
          border: 0;
          border-radius: 0;
          border-bottom: 1px solid $color-primary;
        }
        .el-icon-search {
          color: $color-primary;
          font-size: 25px;
          cursor: pointer;
        }
      }
      &-clear {
        display: block;
        margin-top: 30px;
        text-align: right;
        color: $color-primary;
        cursor: pointer;
      }
    }
    .el-collapse {
      border: none;
      &-item {
        .el-icon-arrow-right {
          &::before {
            content: '展开';
          }
          &.is-active {
            transform: rotate(0);
            &::before {
              content: '收起';
            }
          }
        }
        &__header {
          border: none;
        }
        &__content {
          display: flex;
          justify-content: flex-end;
        }
        .el-checkbox-button {
          display: block;
          margin: 10px 0;
          &.is-checked {
            .el-checkbox-button__inner {
              box-shadow: none;
              background-color: #94bfb2;
              .checked-amount {
                color: $color-primary-light;
                background-color: #fff;
              }
            }
          }
          &__inner {
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            width: 240px;
            max-width: 100vw;
            height: 30px;
            line-height: 30px;
            border-radius: 30px;
            border: 0;
            text-align: left;
            background-color: #f7f7f7;
            .tag-amount {
              margin: 5px 0;
              width: 30px;
              font-size: 12px;
              text-align: center;
              border-radius: 30px;
              line-height: 20px;
              color: #fff;
              background-color: #dddddd;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #map-left-popup {
    .el-drawer {
      padding: 10px 15px;
      padding-left: 65px;
      max-width: 100vw !important;
      &__body {
        padding: 0px;
        overflow: auto;
      }
      .el-collapse-item__content {
        justify-content: center;
      }
    }
  }
}
</style>
